import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledOTPWrapper = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  padding: 32px;

  .otp-verify {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.4px;
  }

  .otp-sent {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    text-align: center;
  }

  .not-receive-otp {
    color: rgba(60, 60, 67, 0.64);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .not-receive-otp-note {
    color: ${COLOR.blueV2};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .error-text {
    color: #ff4d4f;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    text-align: center;
    visibility: ${(props) => !props.error && 'hidden'};
  }

  .otp-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export { StyledOTPWrapper };
